var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "panel border" },
    [
      _c(
        "p",
        {
          staticClass:
            "panel-heading has-text-centered has-text-white border custom-panel-heading",
        },
        [_vm._v(" TOTAL JOBS COMPLETED ")]
      ),
      _c("DashboardProgressBar", {
        attrs: {
          "is-loading": _vm.isLoading,
          "initial-color": "#99C8F7",
          "loading-color": "#0a91a8",
        },
      }),
      _c(
        "div",
        { staticClass: "dashboard-jobs-chart" },
        [
          !!_vm.monthlyReport.length
            ? _c("DashboardJobsChart", {
                staticClass: "has-background-dark canvas-border",
                attrs: {
                  "correct-stage-monthly-jobs": _vm.correctStageMonthlyReport,
                  "wrong-stage-monthly-jobs": _vm.monthlyReport,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }